

export const PRESENTATION_RESOURCES = {
  // Header content
  header: {
    title: "Talk Tree Classroom Activity",
  },


  // Styling constants
  styles: {
    primaryColor: "#1976d2",
    secondaryColor: "#f8f9fa",
    accentColor: "#ff9800",
    containerBackground: "#f9f9f9",
    standardBorder: "1px solid #ddd",
    // Frequently used colors
    buttonPrimary: "#1F72E7",
    pageBackground: "#F9F8F6", 
    loadingBackground: "#f0f4ff",
    errorBackground: "#ffe6e6",
    white: "#fff",
    textColors: {
      primary: "#333333",
      secondary: "#666666",
      light: "#999999"
    }
  },
  // Tab configuration and content
  tabs: {
   introduction: {
      title: "What is a Talk Tree?",
      pages: [
        {
          pageNumber: 1,
          content: {
            heading: ['Introduction to Talk Trees'],
            description: [
              'Talk Trees show what types of statements students have made in class.'
            ],
            pointList: [
              'Blue flower = Making a claim such as "The first step is to divide by 3."',
              'Red flower = Providing an explanation such as "Because you have to multiply before adding."',
              'Yellow flower = Relating to another student\'s contribution such as "I didn\'t get the same answer as she did."',
              'Leaf = any student talk'
            ],
            showSampleTree: true
          }
        },
        {
          pageNumber: 2,
          content: {
            heading: ['What can we do with them?'],
            description: [],
            pointList: [
              'These trees are meant to start conversations and get us thinking about class',
              'When students talk and think about what they are learning, this helps us remember more and be more engaged',
              'We can use the trees to celebrate our accomplishments and set goals for ourselves'
            ],
            showSampleTree: true
          }
        }
      ]
    },
    celebrate: {
      title: "Let's Celebrate!",
        description: [
            "You can use the Talk Trees to celebrate the conversations that students have been having in class. This can be a short acknowledgement or can lead to a longer discussion. Below are some conversation starters that you can use. Select which one's you'd like to include, but note that not all starters will be relevant to all the trees."
      ],
      conversationStarterTitle:  "How can this tree help us celebrate our goals and achievements?",
      conversationStarters: [
            "The ______ flower could be from when we said ________ in class",
            "Something I notice about this tree is ___________",
            "This tree shows that we were ___________ during class",
            "I am proud to see _________ because _________",
            "I see ________, which means we _______ our goal of _________"
            
        // "This tree is very full; we had some productive conversations! Let's try to think about what we did during this class to generate this tree.",
        // "I see all the different types of flowers represented, who remembers which flower means what? Can we think of different examples?",
        // "We had a goal of trying for more explanation, how do you think we did?",
        // "We had a goal of trying to provide more answers, how do you think we did?",
        // "We had a goal of trying to build on each others work, how do you think we did?",
        // "What do you notice about this tree?",
        // "What can we celebrate from this tree?",
        // "What do you remember from class that you felt you did a good job of? Do you think the tree reflects that?"
      ]
    },
    compare: {
      title: "Comparing Trees",
      description: [
        "You can compare the Talk Trees to see how conversations change across classes. This can be useful for general reflection or you can use them set a goal and track your progress. Below are some conversation starters that you can use. Select which one's you'd like to include, but note that not all starters will be relevant to all the trees."
      ],
      conversationStarterTitle:  "Tracking our goals:",
      conversationStarters: [
            "I notice these differences between the trees ____________ and wonder if that means ________________",
            "In the first class we ______________",
            "In the second class we ______________",
            "These trees are different because _________________",
            "Comparing these trees tells me that we _______________ our goals. I think a good next step would be ________"
        // "Let's think about the classes that these trees represent. Who can remember what we did on those days?",
        // "What differences do you notice between the trees?",
        // "Who remembers what the different color flowers represent?",
        // "Why do we think these trees look so different?",
        // "Do you think we are on track with our goal?",
        // "We had a goal of trying for more explanation, how do you think we did?",
        // "We had a goal of trying to provide more answers, how do you think we did?",
        // "We had a goal of trying to build on each others work, how do you think we did?",
        // "What can we do for next class to grow our tree?"
      ]
    }
  },

  tabLabels: ['Introduce Talk Trees', 'Celebrate', 'Compare'],

  messages: {
    selectTree: "Please select a tree first.",
    selectConversationStarter: "Please select at least one conversation starter.",
    selectTwoTrees: "Please select exactly 2 trees for comparison.",
    previewPrompt: "Please select a tree to preview it here.",
    selectTwoTreesPrompt: "Please select exactly 2 trees to preview them here.",
    converting: "Converting tree to image...",
    convertingMultiple: "Converting trees to images...",
    conversionError: "Error converting tree: ",
    conversionErrorMultiple: "Error converting trees: ",
    captureError: "Failed to capture tree image. Please try again.",
    captureErrorMultiple: "Failed to capture tree images. Please try again.",
    generatePresentation: "Generate Presentation",
    proceedWithoutStarters: "You have not selected any conversation starters. Do you want a presentation with only the tree?"
  }
};


export default PRESENTATION_RESOURCES;
